<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent width="350">
        <v-card>
          <v-card-title class="headline">Assinged Course Delete</v-card-title>
          <v-card-text
            >If you delete this assigned course, it is gone for good. Delete
            only if you are sure.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="dangerous-action-btn" @click="deleteItem()"
              >Delete</v-btn
            >
            <v-btn class="cancel-action-btn" @click="dialog = false"
              >Cancel</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-sheet>
      <div class="d-flex justify-end">
        <v-card-actions>
          <v-btn class="default-action-btn" @click="overlay = true"
            >Assign Courses</v-btn
          >
          <v-overlay :value="overlay" class="d-flex">
            <div class="d-flex justify-end">
              <v-btn icon @click="overlay = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </div>
            <course-assign
              :userId="parseInt(userId)"
              @save="save"
            ></course-assign>
          </v-overlay>
        </v-card-actions>
      </div>

      <div class="border">
        <div class="inner-border">Current</div>
        <base-grid
          :showAdd="false"
          :showDelete="false"
          :badgeIcons="badgeIcons"
          :badgeColors="badgeColors"
          :secondaryBadgeIcons="secondaryBadgeIcons"
          :items="incompleteCourses"
          :imageUrls="incompleteCoursesImageUrls"
          v-on:grid:badge:click="
            $router.push({
              name: 'coursesMember',
              params: { id: $event.id }
            })
          "
          v-on:grid:badge:action:click="confirmDeleteItem($event.id)"
          gridId="js-course-grid-current"
        />
      </div>
      <div class="border-bottom">
        <div class="inner-border">Completed</div>
        <base-grid
          :showAdd="false"
          :showDelete="false"
          :items="completedCourses"
          :imageUrls="completedCoursesImageUrls"
          v-on:grid:badge:click="
            $router.push({
              name: 'coursesMentor',
              params: { id: $event.id }
            })
          "
          gridId="js-course-grid-completed"
        />
      </div>
    </v-sheet>
  </div>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"
import titleMixin from "@/mixins/titleMixin"
import BaseGrid from "@/components/BaseGrid"
import CourseAssign from "@/containers/learnings/CourseAssign"
import { mapGetters } from "vuex"

export default {
  mixins: [eventMixin, titleMixin],
  components: {
    BaseGrid,
    CourseAssign
  },
  created() {
    if (this.userId == 0) {
      let id = this.$route.params.id
      this.userId = id
    }

    // Load all courses here, so that store is primed for CourseAssign component
    this.$store.dispatch("courses/loadCourses", {
      showTemplates: true,
      includeHidden: true
    })
    this.addListener("avatar:click", ({ item, source }) => {
      this.$router.push({
        name: "coursesMentor",
        params: { id: item.id }
      })
    })
  },
  data: function() {
    return {
      overlay: false,
      title: "Learning Courses",
      dialog: false,
      deleteItemId: 0
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.params.id) {
      this.$store.dispatch("courses/loadCourses", {
        showTemplates: true,
        includeHidden: true
      })
    }
    next()
  },
  methods: {
    confirmDeleteItem(itemId) {
      this.deleteItemId = itemId
      this.dialog = true
    },
    deleteItem() {
      this.dialog = false
      this.$store.dispatch("courses/deleteCourse", this.deleteItemId)
    },
    save({ available, selected }) {
      this.overlay = false
    }
  },
  computed: {
    ...mapGetters("courses", [
      "getCoursesByUserId",
      "getCompletedCoursesByUserId",
      "getIncompleteCoursesByUserId"
    ]),
    courses() {
      return this.getCoursesByUserId(this.userId)
    },
    imageUrls() {
      return this.courses.map(el => el.badge_url)
    },
    completedCourses() {
      return this.getCompletedCoursesByUserId(this.userId).filter(
        el => !el.hidden
      )
    },
    incompleteCourses() {
      return this.getIncompleteCoursesByUserId(this.userId).filter(
        el => !el.hidden
      )
    },
    completedCoursesImageUrls() {
      return this.completedCourses.map(el => el.badge_url)
    },
    incompleteCoursesImageUrls() {
      return this.incompleteCourses.map(el => el.badge_url)
    },
    badgeIcons() {
      return this.incompleteCourses.map(el =>
        el.touched ? undefined : "mdi-new-box"
      )
    },
    badgeColors() {
      return Array(this.incompleteCourses.length).fill("#cc8556")
    },
    secondaryBadgeIcons() {
      return Array(this.incompleteCourses.length).fill("mdi-close")
    },
    userId: {
      get() {
        return this.$store.state.globals.menteeId
      },
      set(value) {
        this.$store.commit("globals/setMenteeId", value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";
@import "../../scss/course-grid";
</style>
